<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { handleChunkLoadError } from '@/utils/versionCheck'

function onVitePreloadError(event: Event) {
  event.preventDefault()
  void handleChunkLoadError(event)
}

onMounted(() => {
  window.addEventListener('vite:preloadError', onVitePreloadError)
})
onUnmounted(() => {
  window.removeEventListener('vite:preloadError', onVitePreloadError)
})
</script>

<template>
  <div style="display: none"></div>
</template>
